export default ({request}) => ({
  ecomEvgPlatformListApi(data = {}) {
    return request({
      url: '/ecom/evg/platform/list',
      method: 'post',
      data,
    })
  },
  ecomEvgPlatformDetailApi(data = {}) {
    return request({
      url: '/ecom/evg/platform/detail',
      method: 'post',
      data,
    })
  },
  ecomEvgPlatformSaveApi(data = {}) {
    return request({
      url: '/ecom/evg/platform/save',
      method: 'post',
      data,
    })
  },
  ecomEvgPlatformDelApi(data = {}) {
    return request({
      url: '/ecom/evg/platform/del',
      method: 'post',
      data,
    })
  },
  ecomEvgPlatformSubmitApi(data = {}) {
    return request({
      url: '/ecom/evg/platform/submit',
      method: 'post',
      data,
    })
  },
})
